"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _preactCompat = require("preact-compat");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _marked = require("marked");

var _Feedback = require("@insided/shared/modules/HubAI/Feedback");

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _AIAnswersHeader = _interopRequireDefault(require("./AIAnswersHeader"));

var _AIAnswersSkeletonLoader = _interopRequireDefault(require("./AIAnswersSkeletonLoader"));

var _globals2 = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SmartSearchSummary = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SmartSearchSummary, _PureComponent);

  var _super = _createSuper(SmartSearchSummary);

  function SmartSearchSummary() {
    var _this;

    (0, _classCallCheck2.default)(this, SmartSearchSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "abortController", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMounted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeInitiated", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "readTimeSetupStarted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasAutoGenerated", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastSubmittedQuery", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: false,
      topicIds: [],
      documentIds: [],
      isExpanded: false,
      generatedForQuery: undefined,
      showAllResources: false,
      impressionTracked: false,
      contentVisibleAt: null,
      readTimeTimerId: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchSubmit", function (e) {
      if (e.key !== 'Enter') return;
      var target = e.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'search') return;
      if (!target.closest('.instant-search-wrapper')) return;
      var query = target.value.trim();
      if (!query) return; // Skip only when we're already showing — or actively fetching — an answer
      // for this exact query. `data` is cleared whenever the query changes
      // (componentDidUpdate), so returning to a previously-answered query still
      // regenerates instead of being deduped away.

      var fetchingThisQuery = _this.state.loading && _this.lastSubmittedQuery === query;
      var alreadyAnswered = _this.state.generatedForQuery === query;
      if (fetchingThisQuery || alreadyAnswered) return;

      _this.trackAIAnswersEvent('AI Answers Generate Summary Clicked', 'generateSummary');

      void _this.getAskAISearchSummary(query);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tryAutoGenerate", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props$searchSta;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.hasAutoGenerated) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if ((_this$props$searchSta = _this.props.searchState.query) !== null && _this$props$searchSta !== void 0 && _this$props$searchSta.trim()) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _this.hasAutoGenerated = true;
              _context.next = 7;
              return _this.onGenerateClick();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleExpanded", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }); // Track "Continue reading" click when expanding


      _this.trackAIAnswersEvent('AI Answers Continue Reading Clicked', 'continueReading'); // Trigger impression on continue reading


      _this.trackImpression('continue_reading');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerateClick", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _searchState$query;

      var searchState;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchState = _this.props.searchState;

              if ((_searchState$query = searchState.query) !== null && _searchState$query !== void 0 && _searchState$query.trim()) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _this.trackAIAnswersEvent('AI Answers Generate Summary Clicked', 'generateSummary');

              _this.getAskAISearchSummary();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackAIAnswersEvent", function (eventType, elementName) {
      var _searchState$query2;

      var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var searchState = _this.props.searchState;

      _publish.default.trackEvent('userevent', _objectSpread({
        type: eventType,
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: elementName,
        eventDetail: "search.ai-answers.".concat(elementName),
        trackType: 'click',
        searchQuery: (_searchState$query2 = searchState.query) !== null && _searchState$query2 !== void 0 ? _searchState$query2 : ''
      }, extraProps));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackImpression", function (reason) {
      var _searchState$query3;

      // Don't track if already tracked in this session
      if (_this.state.impressionTracked) {
        return;
      }

      var searchState = _this.props.searchState;
      var contentVisibleAt = _this.state.contentVisibleAt; // Calculate read time ONLY for read_time impressions

      var readTimeSeconds;

      if (reason === 'read_time' && contentVisibleAt !== null) {
        readTimeSeconds = Math.round((Date.now() - contentVisibleAt) / 1000).toString();
      }

      var trackingPayload = {
        type: 'AI Answers Impression',
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: 'aiAnswersImpression',
        eventDetail: 'search.ai-answers.impression',
        trackType: 'impression',
        searchQuery: (_searchState$query3 = searchState.query) !== null && _searchState$query3 !== void 0 ? _searchState$query3 : '',
        impressionReason: reason
      }; // Only add readTimeSeconds if it's a read_time impression

      if (readTimeSeconds !== undefined) {
        trackingPayload.readTimeSeconds = readTimeSeconds;
      }

      _publish.default.trackEvent('userevent', trackingPayload); // Mark impression as tracked


      _this.setState({
        impressionTracked: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupReadTimeTracking", function () {
      // Find the content element to observe
      var contentElement = document.querySelector('.answer-content') || document.querySelector('.ai-answer');

      if (!contentElement) {
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Content is now visible in viewport
            // Prevent multiple timer initiations via race condition
            if (!_this.readTimeInitiated && !_this.state.contentVisibleAt) {
              _this.readTimeInitiated = true;
              var visibleAt = Date.now(); // Set timer to check after 15 seconds and batch state updates

              var timerId = window.setTimeout(function () {
                // Check if component is still mounted before calling setState
                if (_this.isMounted) {
                  _this.onReadTimeComplete();
                }
              }, 10000); // Batch setState call to avoid multiple renders

              _this.setState({
                contentVisibleAt: visibleAt,
                readTimeTimerId: timerId
              });
            } // Disconnect observer after first intersection


            observer.disconnect();
          }
        });
      }, {
        threshold: 0.5
      });
      observer.observe(contentElement) // Store observer reference for cleanup
      ;
      (0, _assertThisInitialized2.default)(_this).readTimeObserver = observer;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReadTimeComplete", function () {
      _this.trackImpression('read_time');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cleanupReadTimeTracking", function () {
      // Reset only the initiated flag (NOT setupStarted - that controls setup frequency)
      _this.readTimeInitiated = false; // Clear timer if exists

      if (_this.state.readTimeTimerId) {
        window.clearTimeout(_this.state.readTimeTimerId);
      } // Disconnect observer if exists


      var observer = (0, _assertThisInitialized2.default)(_this).readTimeObserver;

      if (observer) {
        observer.disconnect();
        (0, _assertThisInitialized2.default)(_this).readTimeObserver = null;
      } // Reset state only if still mounted


      if (_this.isMounted) {
        _this.setState({
          contentVisibleAt: null,
          readTimeTimerId: null
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackShowAllResourcesClick", function () {
      var _searchState$query4;

      var searchState = _this.props.searchState;

      _publish.default.trackEvent('userevent', {
        type: 'AI Answers Show All Resources Clicked',
        boundedContext: 'Search',
        entity: 'ai-answers',
        elementName: 'showAllResources',
        eventDetail: 'search.ai-answers.showAllResources',
        trackType: 'click',
        searchQuery: (_searchState$query4 = searchState.query) !== null && _searchState$query4 !== void 0 ? _searchState$query4 : ''
      }); // Trigger impression on show all click


      _this.trackImpression('show_all_click');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFeedbackClick", function (e) {
      var target = e.target;
      var button = target.closest('.feedback--button__like, .feedback--button__dislike');

      if (button !== null && button !== void 0 && button.classList.contains('feedback--button__like')) {
        _this.onFeedbackLike();
      } else if (button !== null && button !== void 0 && button.classList.contains('feedback--button__dislike')) {
        _this.onFeedbackDislike();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackLike", function () {
      _this.trackAIAnswersEvent('AI Answers Feedback Upvote', 'feedbackUpvote');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFeedbackDislike", function () {
      _this.trackAIAnswersEvent('AI Answers Feedback Downvote', 'feedbackDownvote');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAskAISearchSummary", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(queryOverride) {
        var searchState, question, currentQuery, _searchState$refineme, _searchState$refineme2, _searchState$refineme3, _searchState$refineme4, _searchState$refineme5, _searchState$refineme6, _searchState$refineme7, _searchState$refineme8, _searchState$refineme9, _searchState$refineme10, _searchState$hierarch, _searchState$hierarch2, _searchState$hierarch3, _response$body, filters, payload, response, _errorData$rateLimit, errorData, resetInSeconds, resetInHours, errorText, reader, decoder, fullResponse, conversationalText, buffer, chunkCount, _lines$pop, _yield$reader$read, done, value, chunk, lines, _iterator, _step, line, trimmedLine, data, parsed, colonIndex, prefix, content, text, formattedHTML, _toolResult$result, _toolResult$result$hi, toolResult, _response;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                searchState = _this.props.searchState; // Enter-key submits pass the input value explicitly; all other callers
                // (auto-generate, the Generate button) fall back to the current search state.

                question = (queryOverride === null || queryOverride === void 0 ? void 0 : queryOverride.trim()) || searchState.query;

                if (question) {
                  _context3.next = 5;
                  break;
                }

                console.error('[AskAI] Error: No search query provided');
                return _context3.abrupt("return");

              case 5:
                // Store the query we're generating for
                currentQuery = question; // Record it so the Enter-key handler can dedupe an unchanged re-submit.

                _this.lastSubmittedQuery = currentQuery;

                _this.setState({
                  loading: true
                }); // Create a new AbortController for this request


                _this.abortController = new AbortController();
                _context3.prev = 9;
                // Build narrowing filters from active search refinements
                filters = {};

                if ((_searchState$refineme = searchState.refinementList) !== null && _searchState$refineme !== void 0 && (_searchState$refineme2 = _searchState$refineme.gs_data_source) !== null && _searchState$refineme2 !== void 0 && _searchState$refineme2.length) {
                  filters.gs_data_source = searchState.refinementList.gs_data_source;
                }

                if ((_searchState$refineme3 = searchState.refinementList) !== null && _searchState$refineme3 !== void 0 && (_searchState$refineme4 = _searchState$refineme3.content_type) !== null && _searchState$refineme4 !== void 0 && _searchState$refineme4.length) {
                  filters.content_type = searchState.refinementList.content_type;
                }

                if ((_searchState$refineme5 = searchState.refinementList) !== null && _searchState$refineme5 !== void 0 && (_searchState$refineme6 = _searchState$refineme5.tags) !== null && _searchState$refineme6 !== void 0 && _searchState$refineme6.length) {
                  filters.tags = searchState.refinementList.tags;
                }

                if ((_searchState$refineme7 = searchState.refinementList) !== null && _searchState$refineme7 !== void 0 && (_searchState$refineme8 = _searchState$refineme7.locale) !== null && _searchState$refineme8 !== void 0 && _searchState$refineme8.length) {
                  filters.locale = searchState.refinementList.locale;
                }

                if ((_searchState$refineme9 = searchState.refinementList) !== null && _searchState$refineme9 !== void 0 && (_searchState$refineme10 = _searchState$refineme9.source) !== null && _searchState$refineme10 !== void 0 && _searchState$refineme10.length) {
                  filters.source = searchState.refinementList.source;
                }

                if ((_searchState$hierarch = searchState.hierarchicalMenu) !== null && _searchState$hierarch !== void 0 && _searchState$hierarch['categories.lvl0']) {
                  filters.categories = searchState.hierarchicalMenu['categories.lvl0'];
                }

                if ((_searchState$hierarch2 = searchState.hierarchicalMenu) !== null && _searchState$hierarch2 !== void 0 && _searchState$hierarch2['kb.categories.lvl0']) {
                  filters.kb_categories = searchState.hierarchicalMenu['kb.categories.lvl0'];
                }

                if ((_searchState$hierarch3 = searchState.hierarchicalMenu) !== null && _searchState$hierarch3 !== void 0 && _searchState$hierarch3['product_area.lvl0']) {
                  filters.product_area = searchState.hierarchicalMenu['product_area.lvl0'];
                } // Backend generates secured permission filters; frontend filters only narrow results


                payload = {
                  searchTerm: question
                };

                if (Object.keys(filters).length > 0) {
                  payload.filters = filters;
                } // Debug: Print complete payload
                // console.log('[AskAI] Complete payload being sent to backend:', JSON.stringify(payload, null, 2))
                // console.log('[AskAI] Payload details:', {
                //   searchTerm: payload.searchTerm,
                //   searchFilters: payload.searchFilters,
                //   apiKey: payload.apiKey,
                //   communityId: payload.communityId
                // })


                _context3.next = 23;
                return fetch((0, _absoluteUrlRuntime.resolveUrl)('/search/askAISearchSummary', _absoluteUrlRuntime.UrlSourceType.Api), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'text/event-stream',
                    'X-CSRF-Token': (0, _csrfToken.csrfToken)() // Include CSRF token

                  },
                  body: JSON.stringify(payload),
                  signal: _this.abortController.signal // Add abort signal

                });

              case 23:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 52;
                  break;
                }

                console.error('[AskAI] Error: Request failed with status', response.status); // Handle rate limit error specially

                if (!(response.status === 429)) {
                  _context3.next = 41;
                  break;
                }

                _context3.prev = 27;
                _context3.next = 30;
                return response.json();

              case 30:
                errorData = _context3.sent;
                resetInSeconds = (_errorData$rateLimit = errorData.rateLimit) === null || _errorData$rateLimit === void 0 ? void 0 : _errorData$rateLimit.resetIn;

                if (resetInSeconds) {
                  resetInHours = Math.ceil(resetInSeconds / 3600);

                  _this.setState({
                    error: "Whoa there \u2014 you've maxed out your AI answers! Hang tight, your quota will reset in ".concat(resetInHours, " ").concat(resetInHours === 1 ? 'hour' : 'hours', "."),
                    loading: false
                  });
                } else {
                  _this.setState({
                    error: "Whoa there — you've maxed out your AI answers! Hang tight, your quota will reset soon.",
                    loading: false
                  });
                }

                return _context3.abrupt("return");

              case 36:
                _context3.prev = 36;
                _context3.t0 = _context3["catch"](27);
                console.error('[AskAI] Could not parse rate limit error:', _context3.t0);

                _this.setState({
                  error: "Whoa there — you've maxed out your AI answers! Hang tight, your quota will reset soon.",
                  loading: false
                });

                return _context3.abrupt("return");

              case 41:
                _context3.prev = 41;
                _context3.next = 44;
                return response.text();

              case 44:
                errorText = _context3.sent;
                console.error('[AskAI] Error response body:', errorText);
                _context3.next = 51;
                break;

              case 48:
                _context3.prev = 48;
                _context3.t1 = _context3["catch"](41);
                console.error('[AskAI] Could not read error response body:', _context3.t1);

              case 51:
                throw new Error("Request failed: ".concat(response.status));

              case 52:
                // Process SSE stream from backend
                reader = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.getReader();
                decoder = new TextDecoder();
                fullResponse = '';
                conversationalText = '';
                buffer = ''; // Buffer for incomplete lines

                if (reader) {
                  _context3.next = 61;
                  break;
                }

                console.error('[AskAI] Error: No reader available from response body');

                _this.setState({
                  error: 'Failed to read stream',
                  loading: false
                });

                return _context3.abrupt("return");

              case 61:
                chunkCount = 0;

                if (!reader) {
                  _context3.next = 119;
                  break;
                }

              case 63:
                if (!true) {
                  _context3.next = 119;
                  break;
                }

                _context3.next = 66;
                return reader.read();

              case 66:
                _yield$reader$read = _context3.sent;
                done = _yield$reader$read.done;
                value = _yield$reader$read.value;
                chunkCount++;

                if (!done) {
                  _context3.next = 72;
                  break;
                }

                return _context3.abrupt("break", 119);

              case 72:
                // Decode chunk and add to buffer
                chunk = decoder.decode(value, {
                  stream: true
                });
                buffer += chunk; // Process complete lines from buffer

                lines = buffer.split('\n'); // Keep the last incomplete line in the buffer

                buffer = (_lines$pop = lines.pop()) !== null && _lines$pop !== void 0 ? _lines$pop : '';
                _iterator = _createForOfIteratorHelper(lines);
                _context3.prev = 77;

                _iterator.s();

              case 79:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 109;
                  break;
                }

                line = _step.value;
                trimmedLine = line.trim(); // Skip empty lines and SSE comments

                if (!(!trimmedLine || trimmedLine.startsWith(':'))) {
                  _context3.next = 84;
                  break;
                }

                return _context3.abrupt("continue", 107);

              case 84:
                _context3.prev = 84;

                if (!trimmedLine.startsWith('data: ')) {
                  _context3.next = 101;
                  break;
                }

                data = trimmedLine.slice(6).trim();

                if (data) {
                  _context3.next = 89;
                  break;
                }

                return _context3.abrupt("continue", 107);

              case 89:
                parsed = JSON.parse(data); // Handle backend-specific events (connection, error, close)

                if (!(parsed.type === 'connection')) {
                  _context3.next = 93;
                  break;
                }

                _context3.next = 100;
                break;

              case 93:
                if (!(parsed.type === 'error')) {
                  _context3.next = 99;
                  break;
                }

                console.error('[AskAI] Server error event:', parsed.error);

                _this.setState({
                  error: parsed.error || 'Failed to get AI summary',
                  loading: false
                });

                return _context3.abrupt("return");

              case 99:
                if (parsed.type === 'close') {// Stream closed
                }

              case 100:
                return _context3.abrupt("continue", 107);

              case 101:
                // Handle Algolia's custom format (prefixed events)
                if (trimmedLine.includes(':')) {
                  colonIndex = trimmedLine.indexOf(':');
                  prefix = trimmedLine.substring(0, colonIndex);
                  content = trimmedLine.substring(colonIndex + 1); // Handle conversational text chunks (0:"text")

                  if (prefix === '0') {
                    text = JSON.parse(content);
                    conversationalText += text; // Parse Markdown to HTML and update UI in real-time

                    formattedHTML = _marked.marked.parse(conversationalText); // Update UI with streaming text (keep loading: true until stream completes)

                    _this.setState({
                      data: "<div class=\"conversational-text\">".concat(formattedHTML, "</div>"),
                      generatedForQuery: currentQuery
                    });
                  } // Handle tool results with search hits (a:{...})
                  else if (prefix === 'a') {
                    toolResult = JSON.parse(content);

                    if (((_toolResult$result = toolResult.result) === null || _toolResult$result === void 0 ? void 0 : (_toolResult$result$hi = _toolResult$result.hits) === null || _toolResult$result$hi === void 0 ? void 0 : _toolResult$result$hi.length) > 0) {
                      toolResult.result.hits.forEach(function (hit) {
                        var _globals;

                        fullResponse += "<div class=\"resource-card\">"; // Add title
                        // For hub app, prefer content_url (absolute URLs)
                        // For forum/control apps, prefer topic_url (relative URLs)

                        var isHub = ((_globals = (0, _globals2.default)('appState')) === null || _globals === void 0 ? void 0 : _globals.appName) === 'hub';
                        var hitUrl = isHub ? hit.url || hit.content_url || hit.topic_url : hit.url || hit.topic_url || hit.content_url;

                        if (hit.title && hitUrl) {
                          fullResponse += "<h4><a href=\"".concat(hitUrl, "\" target=\"_blank\">").concat(hit.title, "</a></h4>");
                        } else if (hit.title) {
                          fullResponse += "<h4>".concat(hit.title, "</h4>");
                        } // Add description/excerpt if available


                        if (hit.content || hit.reply || hit.first_post) {
                          var description = hit.content || hit.reply || hit.first_post; // Strip HTML tags first

                          var cleanText = description.replace(/<[^>]*>/g, '').trim(); // Replace multiple whitespaces/newlines with single space

                          var singleLineText = cleanText.replace(/\s+/g, ' '); // Truncate to ~100 characters

                          var truncatedDesc = singleLineText.length > 100 ? singleLineText.substring(0, 100).trim() + '...' : singleLineText;
                          fullResponse += "<p class=\"resource-description\">".concat(truncatedDesc, "</p>");
                        }

                        fullResponse += "</div>";
                      });
                    }
                  } // Handle other event types (9: tool calls, f: frames, e: completion, d: done)
                  else if (prefix === '9') {// Tool call event
                  } else if (prefix === 'f') {// Frame event
                  } else if (prefix === 'e') {// Completion event
                  } else if (prefix === 'd') {// Done event
                  }
                }

                _context3.next = 107;
                break;

              case 104:
                _context3.prev = 104;
                _context3.t2 = _context3["catch"](84);
                console.error('[AskAI] Parse error:', _context3.t2, 'Line:', trimmedLine); // Don't show parse errors to user, just log them

              case 107:
                _context3.next = 79;
                break;

              case 109:
                _context3.next = 114;
                break;

              case 111:
                _context3.prev = 111;
                _context3.t3 = _context3["catch"](77);

                _iterator.e(_context3.t3);

              case 114:
                _context3.prev = 114;

                _iterator.f();

                return _context3.finish(114);

              case 117:
                _context3.next = 63;
                break;

              case 119:
                // Process any remaining data in buffer
                if (buffer.trim()) {// Remaining buffer data exists
                } // Final state update with complete response


                if (conversationalText || fullResponse) {
                  _response = SmartSearchSummary.formatResponse(conversationalText, fullResponse);

                  _this.setState({
                    data: _response.conversationalText,
                    resources: _response.resources,
                    loading: false,
                    generatedForQuery: currentQuery
                  });
                } else {
                  _this.setState({
                    error: 'No response received, better luck next time.',
                    loading: false
                  });
                }

                _context3.next = 133;
                break;

              case 123:
                _context3.prev = 123;
                _context3.t4 = _context3["catch"](9);

                if (!(_context3.t4 instanceof Error && _context3.t4.name === 'AbortError')) {
                  _context3.next = 128;
                  break;
                }

                /* 
                  eslint-disable-next-line no-console 
                  */
                console.log('[AskAI] Request aborted due to query change');
                return _context3.abrupt("return");

              case 128:
                console.error('[AskAI] FATAL ERROR in getAskAISearchSummary:', _context3.t4);
                console.error('[AskAI] Error stack:', _context3.t4 instanceof Error ? _context3.t4.stack : 'No stack trace');
                console.error('[AskAI] Error name:', _context3.t4 instanceof Error ? _context3.t4.name : 'Unknown');
                console.error('[AskAI] Error message:', _context3.t4 instanceof Error ? _context3.t4.message : String(_context3.t4));

                _this.setState({
                  error: 'Failed to get AI summary. Please try again.',
                  loading: false
                });

              case 133:
                _context3.prev = 133;
                // Clean up the abort controller
                _this.abortController = null;
                return _context3.finish(133);

              case 136:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[9, 123, 133, 136], [27, 36], [41, 48], [77, 111, 114, 117], [84, 104]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLinkClick", function (eventType, elementName, impressionReason) {
      return function (event) {
        var target = event.target;
        var link = target.closest('a');

        if (link) {
          var _link$getAttribute, _link$textContent;

          var url = (_link$getAttribute = link.getAttribute('href')) !== null && _link$getAttribute !== void 0 ? _link$getAttribute : '';
          var title = (_link$textContent = link.textContent) !== null && _link$textContent !== void 0 ? _link$textContent : '';

          _this.trackAIAnswersEvent(eventType, elementName, {
            sourceUrl: url,
            sourceTitle: title
          }); // Trigger impression on link click


          if (impressionReason) {
            _this.trackImpression(impressionReason);
          }
        }
      };
    });
    return _this;
  }

  (0, _createClass2.default)(SmartSearchSummary, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(previousProps) {
        var _this$state, data, generatedForQuery, searchState, hasVisibleContent;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(previousProps.searchState.query !== this.props.searchState.query)) {
                  _context4.next = 8;
                  break;
                }

                // Clean up previous impression tracking before resetting state
                this.cleanupReadTimeTracking(); // Reset the initiated flag for new query

                this.readTimeInitiated = false; // Reset setup started flag for new query

                this.readTimeSetupStarted = false;
                this.setState({
                  data: undefined,
                  resources: undefined,
                  error: undefined,
                  isExpanded: false,
                  generatedForQuery: undefined,
                  showAllResources: false,
                  impressionTracked: false,
                  contentVisibleAt: null,
                  readTimeTimerId: null
                }); // Cancel ongoing API calls when query changes

                if (this.state.loading) {
                  this.setState({
                    loading: false
                  }); // Cancel fetch request (AbortController)

                  if (this.abortController) {
                    this.abortController.abort();
                    this.abortController = null;
                  }
                } // Don't proceed with automatic summary if query was cleared


                if (this.props.searchState.query) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                if (!(previousProps.searchState.query !== this.props.searchState.query || previousProps.allSearchResults !== this.props.allSearchResults)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 11;
                return this.tryAutoGenerate();

              case 11:
                // Setup read time tracking when content appears and matches current query
                _this$state = this.state, data = _this$state.data, generatedForQuery = _this$state.generatedForQuery;
                searchState = this.props.searchState;
                hasVisibleContent = data && data.replace(/<[^>]*>/g, '').trim().length > 0; // Only setup once per content session - prevent infinite loop

                if (hasVisibleContent && generatedForQuery === searchState.query && !this.readTimeSetupStarted) {
                  this.readTimeSetupStarted = true; // Clean up old timer and setup new one

                  this.cleanupReadTimeTracking();
                  this.setupReadTimeTracking();
                }

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Mark component as unmounted to prevent setState in callbacks
      this.isMounted = false; // Clean up read time tracking on unmount

      this.cleanupReadTimeTracking();
      document.removeEventListener('keydown', this.handleSearchSubmit, true);
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // Mark component as mounted
                this.isMounted = true; // Regenerate the answer when the user presses Enter in the search box —
                // mirrors the Forethought agent. The component persists across in-page
                // searches (no remount), so `tryAutoGenerate` only fires once; this listener
                // is what (re)triggers generation for each subsequent submitted query.

                document.addEventListener('keydown', this.handleSearchSubmit, true); // Auto-generate on mount if conditions are already met

                _context5.next = 4;
                return this.tryAutoGenerate();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
    /**
     * Generates an answer when the user presses Enter inside the full-page search
     * input. Scoped to the search input within `.instant-search-wrapper` and
     * deduped against the last submitted query so an unchanged re-submit is a
     * no-op. `searchState.query` is already updated by the time Enter fires (the
     * InstantSearch state is set synchronously per keystroke; only the URL push is
     * debounced), so the existing generation path picks up the right query.
     */

  }, {
    key: "stateWithGenerateButton",
    value: function stateWithGenerateButton(msg, btnText) {
      var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return (0, _preact.h)("div", {
        className: "ai-answers-generate"
      }, (0, _preact.h)(_AIAnswersHeader.default, null), (0, _preact.h)("div", {
        className: "ai-answers-description"
      }, (0, _preact.h)(_phrase.default, {
        p: "search.ai.answers.getFocusedReply"
      })), (0, _preact.h)("div", {
        className: "ai-answers-spacer"
      }), (0, _preact.h)("button", {
        className: "btn-generate-summary",
        onClick: this.onGenerateClick,
        disabled: disabled
      }, (0, _preact.h)(_phrase.default, {
        p: "search.ai.answers.generateSummary"
      })));
    }
    /**
     * Handles click events on links within AI Answers content
     * Uses event delegation since content is rendered as HTML
     */

  }, {
    key: "renderResourcesSidebar",
    value:
    /**
     * Renders the resources sidebar with loading state and "Show all" functionality
     */
    function renderResourcesSidebar() {
      var _this2 = this;

      var _this$state2 = this.state,
          resources = _this$state2.resources,
          data = _this$state2.data,
          generatedForQuery = _this$state2.generatedForQuery,
          showAllResources = _this$state2.showAllResources,
          loading = _this$state2.loading;
      var searchState = this.props.searchState; // Show skeleton loader when:
      // - We're still loading (streaming in progress)
      // - Data was generated for current query
      // - But resources haven't arrived yet

      var isGeneratingForCurrentQuery = data && generatedForQuery === searchState.query;
      var shouldShowLoader = loading && isGeneratingForCurrentQuery && !resources; // Parse resources HTML to count and filter resource cards

      var resourcesContent = null;
      var showAllButton = null;

      if (resources) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = resources;
        var resourceCards = tempDiv.querySelectorAll('.resource-card');
        var totalResources = resourceCards.length; // Show "Show all" button if there are more than 3 resources and not showing all

        if (totalResources > 3 && !showAllResources) {
          // Only show first 3 resources
          var visibleCards = Array.from(resourceCards).slice(0, 3);
          var limitedHTML = visibleCards.map(function (card) {
            return card.outerHTML;
          }).join('');
          resourcesContent = (0, _preact.h)("div", {
            dangerouslySetInnerHTML: {
              __html: limitedHTML
            }
          });
          showAllButton = (0, _preact.h)("button", {
            className: "btn-show-all-resources",
            onClick: function onClick() {
              _this2.trackShowAllResourcesClick();

              _this2.setState({
                showAllResources: true
              });
            }
          }, (0, _preact.h)(_phrase.default, {
            p: "search.smart.summary.showAll"
          }));
        } else {
          // Show all resources
          resourcesContent = (0, _preact.h)("div", {
            dangerouslySetInnerHTML: {
              __html: resources
            }
          });
        }
      }

      return (0, _preact.h)("div", {
        className: "answer-sidebar"
      }, (0, _preact.h)("div", {
        className: "resources-section",
        onClick: this.handleLinkClick('AI Answers Related Link Clicked', 'relatedLink', 'related_link_click')
      }, resourcesContent, showAllButton, shouldShowLoader && (0, _preact.h)("div", {
        className: "resources-loading"
      }, (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })), (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })), (0, _preact.h)("div", {
        className: "resource-skeleton"
      }, (0, _preact.h)("div", {
        className: "skeleton-title"
      }), (0, _preact.h)("div", {
        className: "skeleton-description"
      })))));
    }
  }, {
    key: "getUIState",
    value: function getUIState() {
      var _searchState$query5;

      // UI State based on priority
      // 1. Empty query (check first to prevent showing stale data)
      // 2. Data (AI summary) - BUT only if it matches current query
      // 3. Loading
      // 4. Error
      // 5. Generate button
      var _this$state3 = this.state,
          loading = _this$state3.loading,
          data = _this$state3.data,
          error = _this$state3.error,
          isExpanded = _this$state3.isExpanded,
          generatedForQuery = _this$state3.generatedForQuery;
      var searchState = this.props.searchState;

      if (!((_searchState$query5 = searchState.query) !== null && _searchState$query5 !== void 0 && _searchState$query5.trim())) {
        return (0, _preact.h)("div", {
          className: "ai-answers-empty-state"
        }, (0, _preact.h)(_AIAnswersHeader.default, null), (0, _preact.h)("span", {
          className: "ai-answers-empty-state-message"
        }, (0, _preact.h)(_phrase.default, {
          p: "search.smart.summary.enterQuery"
        })));
      } // Check if data exists AND it was generated for the current query
      // If query has changed since data was generated, show generate button instead
      // Show data FIRST to avoid flickering when streaming starts
      // Also ensure data has meaningful visible text (not just empty HTML wrappers)


      var hasVisibleContent = data && data.replace(/<[^>]*>/g, '').trim().length > 0;

      if (hasVisibleContent && generatedForQuery === searchState.query) {
        var _searchState$query6;

        var needsTruncation = data.length > 500;
        var isTruncated = needsTruncation && !isExpanded;
        var displayData = isTruncated ? SmartSearchSummary.getTruncatedContent(data) : data;
        var containerClass = "answer-container ".concat(isTruncated ? 'answer-container-truncated' : 'answer-container-expanded');
        return (0, _preact.h)("div", {
          className: containerClass
        }, (0, _preact.h)("div", {
          className: "answer-wrapper",
          "aria-live": "polite"
        }, (0, _preact.h)("div", {
          className: "answer-content"
        }, (0, _preact.h)(_AIAnswersHeader.default, {
          className: "ai-answers-header-with-content",
          title: loading ? 'Generating...' : 'AI Answers'
        }), (0, _preact.h)("div", {
          className: "ai-answer",
          dangerouslySetInnerHTML: {
            __html: displayData
          },
          onClick: this.handleLinkClick('AI Answers Content Link Clicked', 'contentLink', 'source_click')
        })), this.renderResourcesSidebar()), isTruncated && (0, _preact.h)("div", {
          className: "btn-continue-reading-container"
        }, (0, _preact.h)("button", {
          className: "btn-continue-reading",
          onClick: this.toggleExpanded
        }, (0, _preact.h)(_phrase.default, {
          p: "search.smart.summary.continueReading"
        }))), !isTruncated && searchState.query && (0, _preact.h)("div", {
          className: "ai-answers-footer"
        }, (0, _preact.h)("div", {
          className: "ai-answers-feedback",
          onClick: this.handleFeedbackClick
        }, (0, _preact.h)(_Feedback.Feedback, {
          options: ['Inaccurate content', 'Outdated summary', 'Summary is too long', 'Complex to understand', 'Query not answered'],
          featureName: "search-summary",
          input: (_searchState$query6 = searchState.query) !== null && _searchState$query6 !== void 0 ? _searchState$query6 : '',
          output: data !== null && data !== void 0 ? data : '',
          topicIds: this.state.topicIds,
          documentIds: this.state.documentIds
        })), (0, _preact.h)("span", {
          className: "ai-answers-disclaimer"
        }, "AI-generated response. It may occasionally be incorrect or incomplete. Always verify with official documentation.")));
      } // Show loader if still loading and no visible content yet. The skeleton
      // (text bars + source cards) mirrors the eventual answer layout and holds
      // the box at its 320px initial height so it doesn't jump when content lands.


      if (loading && !hasVisibleContent) {
        return (0, _preact.h)("div", {
          className: "ai-answers-loading"
        }, (0, _preact.h)(_AIAnswersHeader.default, {
          title: "Generating..."
        }), (0, _preact.h)(_AIAnswersSkeletonLoader.default, null));
      } // Check if we should disable the generate button:
      // - If we're currently loading (have data but still streaming)
      // - AND the query hasn't changed (generatedForQuery matches current query)


      var shouldDisableButton = loading && generatedForQuery === searchState.query;
      if (error) return this.stateWithGenerateButton(error, 'Retry', shouldDisableButton);
      return this.stateWithGenerateButton('search.smart.summary.generateSummary', 'search.smart.summary.generate', shouldDisableButton);
    }
  }, {
    key: "render",
    value: function render() {
      var hidden = this.props.hidden;
      return (0, _preact.h)("div", {
        className: "ai-answers-summary",
        hidden: hidden
      }, (0, _preact.h)("div", {
        className: "content"
      }, this.getUIState()));
    }
  }], [{
    key: "formatResponse",
    value: // Helper function to format the response with proper styling
    function formatResponse(conversationalText, fullResponse) {
      // Store both conversational text and resources separately. Wrap in
      // `.conversational-text` so the typography rules in style.scss (heading
      // scale, paragraph sizing, list spacing) apply — without this, the
      // markdown output falls through to global element selectors and the
      // headings render at the platform-wide sizes (h3 = 20px, etc.). The
      // streaming path (see line ~558) wraps the same way, so this just
      // keeps the wrapper consistent across both rendering paths.
      var formattedHTML = conversationalText ? "<div class=\"conversational-text\">".concat(_marked.marked.parse(conversationalText), "</div>") : ''; // Return an object with both parts

      return {
        conversationalText: formattedHTML,
        resources: fullResponse
      };
    }
  }, {
    key: "getTruncatedContent",
    value: function getTruncatedContent(html) {
      // Simple truncation - extract first few paragraphs or first ~3000 characters
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html; // Get all paragraph elements

      var paragraphs = tempDiv.querySelectorAll('p, h1, h2, h3, h4, h5, h6, ul, ol');

      if (paragraphs.length === 0) {
        // If no structured content, just truncate by character count
        return html.substring(0, 3000) + '...';
      } // Take first 2-3 elements (or until we reach ~3000 characters)


      var truncatedHTML = '';
      var charCount = 0;
      var maxChars = 3000;
      var maxElements = 6;

      for (var i = 0; i < Math.min(paragraphs.length, maxElements); i++) {
        var _element$textContent;

        var element = paragraphs[i];
        var elementText = (_element$textContent = element.textContent) !== null && _element$textContent !== void 0 ? _element$textContent : '';

        if (charCount + elementText.length > maxChars && i > 0) {
          break;
        }

        truncatedHTML += element.outerHTML;
        charCount += elementText.length;
      }

      return truncatedHTML || html.substring(0, 3000) + '...';
    }
  }]);
  return SmartSearchSummary;
}(_preactCompat.PureComponent);

var _default = (0, _connectors.connectStateResults)(SmartSearchSummary);

exports.default = _default;